import React from 'react';
import styled from 'styled-components';
import { Typography } from 'src/typography';
import { StyledLink } from 'shared/components';

type ColoradoWarningProps = {
  isFirst?: boolean;
};

const warningHeader = 'Warning:';

const warningText =
  'Using marijuana, in any form, while you are pregnant or breastfeeding passes THC to your baby and may be harmful to your baby. There is no known safe amount of marijuana use during pregnancy or breastfeeding.';

const acknowledgementText = 'By placing an order you acknowledge receipt of this';

const linkText = 'CO Regulated Marijuana Concentrate educational material.';

const ColoradoWarning: React.FC<ColoradoWarningProps> = ({ isFirst }) => (
  <>
    <WarningBody size='xxsmall' isFirst={isFirst} data-testid='colorado-warning'>
      <Bold>{warningHeader} </Bold>
      {warningText}
    </WarningBody>
    <WarningBody size='xxsmall'>
      {acknowledgementText}{' '}
      <StyledLink
        href='https://sbg.colorado.gov/sites/sbg/files/211101%20MED%20Educational%20Resource.pdf'
        target='_blank'
      >
        {linkText}
      </StyledLink>
    </WarningBody>
  </>
);

const Bold = styled.strong`
  font-weight: bold;
  text-transform: uppercase;
`;

const WarningBody = styled(Typography.Body)<{ isFirst?: boolean }>`
  color: #909ca7;
  font-size: 11px;
  line-height: 17px;
  margin-top: ${({ isFirst }) => (isFirst ? '24px' : '12px')};
  text-align: center;
`;

export default ColoradoWarning;
